/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 1/5/16.
 */
'use strict';
angular.module('prism-ui.content').controller('AddShowLiveFeedModalController', function ($uibModalInstance, ContentEditService, availableFeeds, showLiveFeed) {
	var self = this;
	self.liveFeeds = availableFeeds;
	self.showLiveFeed = showLiveFeed;

	self.onOk = function () {
		$uibModalInstance.close(showLiveFeed);
	};

	self.cancel = function () {
		$uibModalInstance.dismiss('cancel');
	};

	self.disableOKButton = function () {
		return !self.showLiveFeed.liveFeed || self.modalForm.$pristine;
	};

	self.isDefaultFeedSet = function () {
		var isSet = false;
		angular.forEach(ContentEditService.contentObject.liveFeeds, function(liveFeed) {
			if(liveFeed.defaultFlag) {
				isSet = true;
			}
		});
		return isSet;
	};
});
